import { render, staticRenderFns } from "./InfoTitle.vue?vue&type=template&id=43ac7e3c&"
import script from "./InfoTitle.vue?vue&type=script&lang=js&"
export * from "./InfoTitle.vue?vue&type=script&lang=js&"
import style0 from "./InfoTitle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43ac7e3c')) {
      api.createRecord('43ac7e3c', component.options)
    } else {
      api.reload('43ac7e3c', component.options)
    }
    module.hot.accept("./InfoTitle.vue?vue&type=template&id=43ac7e3c&", function () {
      api.rerender('43ac7e3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Statistics/TouchpointInfo/InfoTitle.vue"
export default component.exports